/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Savechanges1Inputs */

const en_common_savechanges1 = /** @type {(inputs: Common_Savechanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Common_Savechanges1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_savechanges1 = /** @type {((inputs?: Common_Savechanges1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Savechanges1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_savechanges1(inputs)
});
export { common_savechanges1 as "common_saveChanges" }